import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import axios from '@/api/Interceptor.js';
import '@/styles/all.css';

import '@/assets/css/common.less';
import * as directives from '@/directives.js';

//引入echarts
import echarts from 'echarts';
Vue.prototype.$echarts = echarts;

//  引入iconfont
import './assets/iconfont/iconfont.css';

// 引入element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.prototype.axios = axios;
Vue.config.productionTip = false;
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key]);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
